<template>
  <div class="children_file" >
     <div class="children_file_top">
        <div class="children_file_topl">
           <img src="../../assets/images/jigsaw/back.png" class="children_file_back" @click="goback()" />
        </div>
        <div class="children_file_topr">
           <div class="left-add">
               <img src="../../assets/images/children-file/add-btn.png" class="children_file_top_add" @click="addChild">
               <p>新增儿童</p>
           </div>
            <img src="../../assets/images/children-file/left.png" class="children_file_top_left" @click="prev">
            <div class="children_file_top_fileList" ref="box">
               <div class="children_file_top_file_list" >
                  <span class="children_file_top_file_list_item"
                  :class="activeIndex == index ? 'active' : 'other'"
                  v-for="(item,index) in childrenList" :key="item.id"
                  @click="activeChange(index,item.id,item.sex)">
                     <img :src="item.headImg" class="children_file_top_file_list_item_img">
                     <span class="children_file_top_file_list_item_name">{{item.studentName}}</span>
                  </span>
               </div>
            </div>
            <img src="../../assets/images/children-file/right.png" class="children_file_top_right" @click="next">
            <p class="children_file_topr_prompt">填写信息,让我们彼此了解吧~</p>
            <img src="../../assets/images/children-file/cartoon-child.png" class="children_file_topr_cartoon">
        </div>
     </div>
     <div class="children_file_content">
        <div class="children_file_content_left">
           <div class="children_file_content_left_bookMark">
              <p class="children_file_content_left_bookMarkTitle"
              :class="componentName.indexOf(val.componentName) != -1 ? 'is_active' : ''"
              v-for="(val,index) in bookMarkList" :key="index"
              @click="markChange(val.componentName)">
               <span>{{val.title}}</span>
              </p>
           </div>
        </div>
        <div class="children_file_content_right">
           <teamMembers :componentData="componentData" v-if="componentName == 'teamMembers'"></teamMembers>
           <addBasicInformation :componentData="componentData" :sex="currentSex" @saveChild="saveChild" v-if="componentName == 'addBasicInformation'"></addBasicInformation>
           <editBasicInformation :componentData="componentData" v-if="componentName == 'editBasicInformation'" ></editBasicInformation>
           <hobby :componentData="componentData" v-if="componentName == 'hobby'" @addHobby="editHobby" @delHobby="editHobby" @saveHobby="editHobby"></hobby>
           <tag :componentData="componentData" v-if="componentName == 'tag'" @delTag="editTag" @addTag="editTag" @saveTag="saveTag"></tag>
           <photoWall :componentData="componentData" v-if="componentName == 'photoWall'" @addPhoto="editPhoto" @delPhoto="editPhoto"></photoWall>
           <!-- <component :is="componentName" :componentData="componentData" @saveChild="saveChild"></component> -->
        </div>
     </div>
  </div>
</template>

<script>
import teamMembers from '../../components/children-file/team-members.vue'; // 小组成员
import addBasicInformation from '../../components/children-file/add-basic-information.vue'; // 新增儿童信息
import editBasicInformation from '../../components/children-file/edit-basic-information.vue'; // 编辑基本信息
import hobby from '../../components/children-file/hobby.vue'; // 爱好
import tag from '../../components/children-file/tag.vue'; // 标签
import photoWall from '../../components/children-file/photo-wall.vue'; // 照片墙
import {horizontalScreen} from '../../assets/js/horizontal'; // 横屏
import { encryptBy } from '@/assets/js/encryption'; // 字符串加密
import BScroll from "better-scroll";
import {
   _getChildren, // 查询儿童接口
   _getChild, // 查询单个儿童接口
   _getFavoriteLabel
} from '../../api/children-file';
export default {
   name:'children-file',
   components:{
      teamMembers,
      addBasicInformation,
      editBasicInformation,
      hobby,
      tag,
      photoWall
   },
   data() {
      return {
         componentName:'editBasicInformation', // 组件名称
         activeIndex:null, // 当前选中儿童的标识符
         childrenList:[], // 小组成员
         bookMarkList:[
            {title:'小组成员',componentName:"teamMembers"},
            { title:'基本信息',componentName:'BasicInformation'},
            {title:'爱好',componentName:'hobby'},
            {title:'标签',componentName:'tag'},
            {title:'照片墙',componentName:'photoWall'}
            ],
         current:0, // 当前距离左边的小组成员所在数组中的下标
         studentId:'', // 当前儿童的id
         componentData:{
            groupList:[], // 小组成员列表
            photoWallList:[], // 照片墙
            hobbyList:[
               {title:"喜欢的明星",code:'star',key:'favoriteStar',customKey:'customFavoriteStar',hobbyList:[],customHobbyList:[]},
               {title:"喜欢的颜色",code:'color',key:'favoriteColor',customKey:'customFavoriteColor',hobbyList:[],customHobbyList:[]},
               {title:"喜欢的运动",code:'sport',key:'favoriteSport',customKey:'customFavoriteSport',hobbyList:[],customHobbyList:[]},
               {title:"喜欢的歌曲",code:'song',key:'favoriteSong',customKey:'customFavoriteSong',hobbyList:[],customHobbyList:[]},
               {title:"喜欢的书",code:'book',key:'favoriteBook',customKey:'customFavoriteBook',hobbyList:[],customHobbyList:[]},
               {title:"喜欢的游戏",code:'game',key:'favoriteGame',customKey:'customFavoriteGame',hobbyList:[],customHobbyList:[]}
            ], // 爱好列表
            favoriteAndLabelId:'',// 爱好Id
            basicData:{}, // 基础信息
            studentId:'', // 当前儿童的id
            choiceLabelList:[], //勾选的默认标签
            labelList:[], // 默认标签
            labelShow:[], // 控制默认标签是否展示
            choiceCustomLabelList:[], // 勾选的自定义标签
            customLabelShow:[], // 控制自定义标签是否展示
            customLabelList:[], // 自定义标签
            loading:false,
            currentSex:null, // 当前儿童的性别
         },
      }
   },
   computed:{},
   created() {
     this.studentId = localStorage.getItem('childId');
     this.componentData.studentId = this.studentId;
     // 获取儿童列表
     this.queryChildren();
     // 查询当前儿童信息
     this.queryChild(this.studentId);
      // 查询儿童标签爱好列表
     this.queryFavoriteLabel(this.studentId);
     var app=document.getElementById("app");
      var touchstartY;
      app.addEventListener("touchstart",function(event){
         var events=event.touches[0]||event;
         touchstartY=events.clientY;//获取触摸目标在视口中的y坐标
      },false);
      app.addEventListener("touchmove",function(event){
         var events=event.touches[0]||event;
         //注意document.body.scrollTop始终为0
         var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;//获取滚动部分的高度
         var clientHeight=document.documentElement.clientHeight;//获取手机屏幕高度（可视部分高度）
         var scrollHeight=document.body.scrollHeight;//所有内容的高度
         if(events.clientY>touchstartY&&scrollTop===0&&event.cancelable){
            event.preventDefault();//禁止到顶下拉
         }else if(scrollTop+clientHeight>scrollHeight&&event.cancelable){
            event.preventDefault();//禁止到底上拉
         }
      },false);
   },
   mounted() {
      horizontalScreen();
   },
   methods:{
      // 获取儿童列表
      queryChildren() {
         this.loading = true;
          _getChildren().then(res=>{
             this.loading = false;
             if(res.code == 200){
                 let dataList = res.data;
                 localStorage.setItem("children", encryptBy(JSON.stringify(res.data)));
                 dataList.map((item,index) => {
                    if(this.studentId == item.id){
                       this.activeIndex = index
                       this.currentSex = item.sex;
                    }
                    if(!item.headImg){
                       item.headImg = item.sex == 1 ? require('../../assets/images/head/boy.png') : require('../../assets/images/head/girl.png');
                    }else{
                     //   item.headImg = 'http://' + location.host + '/' + item.headImg;
                     item.headImg = item.headImg;
                    }
                 })
                 this.childrenList = dataList
                  // 儿童列表滚动效果
                  this.$nextTick(()=>{
                     let bs = new BScroll('.children_file_top_fileList',{
                        pullUpLoad: true,
                        // scrollbar: true,
                        pullDownRefresh: true,
                        scrollX:true,
                        scrollY:false,
                        bounce:false,
                        click:true,
                        quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
                     })
                  })
             }else{
                Toast({message:res.message,className:'rotation'})
             }
         })
      },
      // 查询某个儿童信息
      queryChild(studentId) {
         this.loading = true
         this.componentData.groupList = [];
         this.componentData.photoWallList = [];
         this.componentData.basicData = {};
         _getChild(studentId).then(res=>{
             this.loading = false;

            if(res.code == 200){
               this.componentData.basicData = res.data

               if(JSON.stringify(res.data) != "{}"){

                     res.data.groupList&&res.data.groupList.map(item => {
                        if(!item.headImg){
                           item.headImg = item.sex == 1 ? require('../../assets/images/head/boy.png') : require('../../assets/images/head/girl.png');
                        }else{
                           // item.headImg = 'http://' + location.host + '/' + item.headImg;
                           item.headImg = item.headImg;
                        }
                        if(item.psyStudentFavoriteLabelVO && JSON.stringify(item.psyStudentFavoriteLabelVO) != "{}"){
                           item.psyStudentFavoriteLabelVO.labelList = item.psyStudentFavoriteLabelVO.labels ? item.psyStudentFavoriteLabelVO.labels.split(",") : []
                           item.psyStudentFavoriteLabelVO.customLabelList = item.psyStudentFavoriteLabelVO.customLabels ? item.psyStudentFavoriteLabelVO.customLabels.split(",") : []
                        }
                     })

                  this.componentData.groupList = res.data.groupList; // 小组成员

                  this.componentData.photoWallList = res.data.photoWall; // 照片墙

               }
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      // 查询儿童标签爱好接口
      queryFavoriteLabel(studentId) {
         this.componentData.hobbyList = [
            {title:"喜欢的明星",code:'star',type:"1",hobbyList:[],choiceHobby:[],hobbyShowList:[],customHobbyShowList:[],customHobbyList:[],choiceCustomHobby:[]},
            {title:"喜欢的颜色",code:'color',type:"2",hobbyList:[],choiceHobby:[],hobbyShowList:[],customHobbyShowList:[],customHobbyList:[],choiceCustomHobby:[]},
            {title:"喜欢的运动",code:'sport',type:"3",hobbyList:[],choiceHobby:[],hobbyShowList:[],customHobbyShowList:[],customHobbyList:[],choiceCustomHobby:[]},
            {title:"喜欢的歌曲",code:'song',type:"4",hobbyList:[],choiceHobby:[],hobbyShowList:[],customHobbyShowList:[],customHobbyList:[],choiceCustomHobby:[]},
            {title:"喜欢的书",code:'book',type:"5",hobbyList:[],choiceHobby:[],hobbyShowList:[],customHobbyShowList:[],customHobbyList:[],choiceCustomHobby:[]},
            {title:"喜欢的游戏",code:'game',type:"6",hobbyList:[],choiceHobby:[],hobbyShowList:[],customHobbyShowList:[],customHobbyList:[],choiceCustomHobby:[]}
         ]
         this.componentData.customLabelList = [];
         this.componentData.customLabelShow = [];
         this.componentData.choiceCustomLabelList = [];
         this.componentData.choiceLabelList = [];
         this.componentData.labelList = [];
         this.componentData.labelShow = []
         _getFavoriteLabel({studentId:studentId,type:''}).then(res=>{
            if(res.code == 200){
               let dataList = res.data;
               if(dataList.length > 0){
                  dataList.map(item => {
                     // 爱好
                     this.componentData.hobbyList.map(val => {
                        if(item.type == val.type){
                           // 自定义标签
                           if(item.customEnable){
                              val.customHobbyList.push({
                                 label:item.label,
                                 id:item.id,
                                 sort:item.sort,
                                 type:item.type,
                                 studentId:item.studentId
                              })
                              val.customHobbyShowList.push(false);
                              // 勾选
                              if(item.checkEnable){
                                 val.choiceCustomHobby.push({
                                    label:item.label,
                                    id:item.id,
                                    sort:item.sort,
                                    type:item.type,
                                    studentId:item.studentId
                                 })
                              }
                           }else{
                              val.hobbyList.push({
                                 label:item.label,
                                 id:item.id,
                                 sort:item.sort,
                                 type:item.type,
                                 studentId:item.studentId
                              })
                              val.hobbyShowList.push(false);
                              if(item.checkEnable){
                                 val.choiceHobby.push({
                                    label:item.label,
                                    id:item.id,
                                    sort:item.sort,
                                    type:item.type,
                                    studentId:item.studentId
                                 })
                              }
                           }
                        }
                     })
                     // 标签
                     if(item.type == 7){
                        // 自定义标签
                        if(item.customEnable){
                           this.componentData.customLabelList.push({
                                label:item.label,
                                 id:item.id,
                                 sort:item.sort,
                                 type:item.type,
                                 studentId:item.studentId
                           })
                           this.componentData.customLabelShow.push(false)
                           // 勾选
                           if(item.checkEnable){
                              this.componentData.choiceCustomLabelList.push({
                                 label:item.label,
                                 id:item.id,
                                 sort:item.sort,
                                 type:item.type,
                                 studentId:item.studentId
                              })
                           }
                        }else{
                           this.componentData.labelList.push({
                                label:item.label,
                                 id:item.id,
                                 sort:item.sort,
                                 type:item.type,
                                 studentId:item.studentId
                           })
                           this.componentData.labelShow.push(false)
                           // 勾选
                           if(item.checkEnable){
                              this.componentData.choiceLabelList.push({
                                 label:item.label,
                                 id:item.id,
                                 sort:item.sort,
                                 type:item.type,
                                 studentId:item.studentId
                              })
                           }
                        }
                     }

                  })
               }
            }
         })
      },
      // 新增儿童
      addChild() {
         this.componentName = 'addBasicInformation';
      },
      // 切换儿童
      activeChange(index,studentId,sex) {
         this.activeIndex = index;
         this.currentSex = sex;
         this.componentData.studentId = studentId
         // 查询当前儿童的信息及标签、爱好
         this.queryChild(studentId)
         this.queryFavoriteLabel(studentId);
      },
      // 左侧菜单切换
      markChange(componentName) {
        this.componentName = componentName == 'BasicInformation' ? 'editBasicInformation' : componentName;
        if( this.componentName == 'editBasicInformation'){
           this.queryChild(this.studentId)
        }
      },
      // 小组成员左箭头点击滑动
      prev() {
         if(this.current < this.childrenList.length - 1){
            let _this =  document.getElementsByClassName("children_file_top_file_list_item")[this.current];
            let target = document.getElementsByClassName('children_file_top_file_list')[0];
            let parent = document.getElementsByClassName('children_file_top_fileList')[0];
            let parentWidth = Number(window.getComputedStyle(parent).width.slice(0,-2));
            let targetWidth = Number(window.getComputedStyle(target).width.slice(0,-2));
            let offsetLeft = target.offsetLeft;
            let width = Number(window.getComputedStyle(_this).width.slice(0,-2));
            let space = Number(window.getComputedStyle(_this).marginRight.slice(0,-2));
            //  如果剩下的小组成员模块的宽度之大于外层父元素的宽度，则可以往左滑
           if((targetWidth - Math.abs(offsetLeft)) > parentWidth){
              target.style.left = offsetLeft - width - space + 'px';
              this.current += 1;
           }
         }
      },
      // 小组成员右箭头点击滑动
      next() {
         if(this.current > 0){
            this.current -= 1;
            let _this =  document.getElementsByClassName("children_file_top_file_list_item")[this.current];
            let target = document.getElementsByClassName('children_file_top_file_list')[0];
            let offsetLeft = target.offsetLeft;
            let width = Number(window.getComputedStyle(_this).width.slice(0,-2));
            let space = Number(window.getComputedStyle(_this).marginRight.slice(0,-2));
            target.style.left = offsetLeft + width + space +'px';
         }
      },
      //返回上一页面
      goback() {
         this.$router.go(-1);
      },
      // 新增儿童信息后获取当前新增儿童信息
      saveChild(studentId) {
         this.studentId = studentId;
         this.componentData.studentId = studentId;
         this.queryChildren();
         this.queryChild(this.studentId);
          this.queryFavoriteLabel(this.studentId);
         this.componentName = 'editBasicInformation';
      },
      // 编辑自定义爱好
      editHobby(hobbyList) {
         this.componentData.hobbyList = hobbyList;
      },
      // 编辑自定义标签
      editTag(tagList) {
         this.componentData.customLabelList = tagList;
      },
      // 保存自定义标签
      saveTag(customTagList,choiceCustomList,choiceList,tagShowList,customTagShowList) {
         this.componentData.customLabelList = customTagList;
         this.componentData.choiceCustomLabelList = choiceCustomList;
         this.componentData.choiceLabelList = choiceList;
         this.componentData.labelShow = tagShowList;
         this.componentData.customLabelShow = customTagShowList;
      },
      // 编辑照片墙
      editPhoto(photoList) {
         this.componentData.photoWallList = photoList;
      },
   },
}
</script>

<style lang="scss" scoped>
.children_file{
   width:100%;
   height:100%;
   background:url('../../assets/images/children-file/bg.png') no-repeat;
   background-size:cover;
   position: relative;
   .children_file_top{
      // position: absolute;
      // left:0;
      // top:0;
      width:100%;
      display:flex;
      // z-index:5;
      // background:url('../../assets/images/children-file/bg.png') -74px 0 no-repeat;
      // background-size:cover;
      // justify-content: space-around;
      .children_file_topl{
         .children_file_back{
            width:29px;
            height:29px;
            margin:15px 15px 0 15px;
            border-radius:25px;
         }
      }
      .children_file_topr{
         margin-top:10px;
         width:calc(100% - 29px);
         display: flex;
         .left-add {
            p {
               font-size: 12px;
               color: #fff;
               text-shadow: 0px 1px 1px #AF773E;
               height: 14px;
               line-height: 14px;
               white-space: nowrap;
               margin-top: 3px;
            }
         }
         .children_file_top_add{
            width:30px;
            height:30px;
            // margin:20px 0px 8px 0;
            margin-top: 12px;
            margin-left: 8px;
         }
         .children_file_top_left,.children_file_top_right{
            width:14px;
            height:24px;
         }
         .children_file_top_left{
            // margin:24px 0 11px 8px;
            margin:24px 0 11px 0px;
            cursor: pointer;
         }
         .children_file_top_right{
            margin:24px 8px 11px 8px;
            cursor: pointer;
         }
         .children_file_topr_prompt{
            width:68px;
            min-height:44px;
            background:url('../../assets/images/children-file/bubble-frame.png') no-repeat;
            background-size: cover;
            color:#FF7C1F;
            font-family: PingFangSC-Medium, PingFang SC;
            font-size:10px;
            font-weight:500;
            line-height: 14px;
            padding:2px 6px 0 4px;
            margin:13px 4px 3px 0;
         }
         .children_file_topr_cartoon{
            width:36px;
            height:58px;
         }
         .children_file_top_fileList{
            width:calc(100% - 214px);
            margin-left:10px;
            padding-top:13px;
            position: relative;
            overflow: hidden;
            .children_file_top_file_list{
               display: inline-block;
               width:auto;
               height:44px;
               position: absolute;
               left:0px;
               top:13px;
               z-index:1;
               white-space: nowrap;
               transition:left 0.8s;
               margin-bottom:8px;
               overflow-x: auto;
               .children_file_top_file_list_item{
                     display: inline-block;
                     padding:7px 12px;
                     min-width:92px;
                     font-size:16px;
                     font-weight:400;
                     font-family: PingFangSC-Regular, PingFang SC;
                     height:44px;
                     box-sizing: border-box;

                     &:not(:last-child){
                        margin-right:10px;
                     }
                     &.other{
                        border:2px solid #FF8400;
                        border-radius: 8px;
                        background: #fff;
                        vertical-align: top;
                        padding:5px 10px;
                     }
                     &.active{
                        background: url('../../assets/images/children-file/selected.png') no-repeat;
                        background-size: 100% 100%;
                        vertical-align: top;
                        .children_file_top_file_list_item_name{
                           color:#fff;
                        }
                     }
                     .children_file_top_file_list_item_img{
                        width:30px;
                        height:30px;
                        margin-right:6px;
                        vertical-align: middle;
                     }
                     .children_file_top_file_list_item_name{
                        font-size:16px;
                        color:#FF8340;
                        font-weight: 400;
                        vertical-align: middle;
                     }
                  }
            }

         }
      }
   }
   .children_file_content{
      // width:587px;
      width:auto;
      height:287px;
      background: url('../../assets/images/children-file/book-page.png') no-repeat;
      background-size: 100% 100%;
      margin:10px 20px 0 60px;
      position: relative;
      .children_file_content_left{
         position:absolute;
         left:-5%;
         top:40px;
         z-index:10;
         .children_file_content_left_bookMark{
            font-size:12px;
            font-weight:400;
            font-family:PingFangSC-Regular, PingFang SC;
            .children_file_content_left_bookMarkTitle{
               color:#74410A;
               width:66px;
               height:30px;
               box-shadow: 0 -2px 0 0 #FFE3D5,0 1px 1px 0 #F4A95D;
               // box-shadow:0 -1px 1px 0 #F4A95D,0 2px 0 0 #FFE3D5;
               background:#FFE5CA;
               padding:7px 9px;
               border-radius:8px 0 0 8px;
               text-align: center;
               box-sizing: border-box;
               &:not(:last-child){
                  margin-bottom:10px;
               }
            }
            .is_active{
               width:81px;
               height:30px;
               color:#fff;
               box-shadow:0 0 0 0;
               // text-shadow: 0 0 2px rgba(109,19,19,0.5);
               background:transparent url('../../assets/images/children-file/choice-tag.png') no-repeat;
               background-size:100% 100%;
               padding:7px 24px 7px 9px;
            }

         }
      }
      .children_file_content_right{
         width:100%;
         height:100%;
      }
   }
    ::v-deep .van-popup--round {
      z-index: 10000!important;
   }
}
</style>
